import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  createFormField,
  FormFieldBlueprint,
} from '@backstage/plugin-scaffolder-react/alpha';

import {
  DaasApplicationInput,
  daasApplicationInputValidation,
  DaasApplicationSetInput,
  daasApplicationSetInputValidation,
} from './fields/DaasApplicationInput';
import {
  DaasComponentPicker,
  daasComponentPickerValidation,
} from './fields/DaasComponentPicker';
import {
  DaasProjectInput,
  daasProjectInputValidation,
} from './fields/DaasProjectInput';

// `name` is the value used as `ui:field` in the template YAML. The four names
// below are a contract with `templates/daas/**` and with entities already
// deployed, so they must not drift.
const fields: Array<{
  id: string;
  name: string;
  component: any;
  validation?: any;
}> = [
  {
    id: 'daas-project-input',
    name: 'DaasProjectInput',
    component: DaasProjectInput,
    validation: daasProjectInputValidation,
  },
  {
    id: 'daas-application-input',
    name: 'DaasApplicationInput',
    component: DaasApplicationInput,
    validation: daasApplicationInputValidation,
  },
  {
    id: 'daas-application-set-input',
    name: 'DaasApplicationSetInput',
    component: DaasApplicationSetInput,
    validation: daasApplicationSetInputValidation,
  },
  {
    id: 'daas-component-picker',
    name: 'DaasComponentPicker',
    component: DaasComponentPicker,
    validation: daasComponentPickerValidation,
  },
];

/**
 * Registers the custom scaffolder form-field extensions used by the DaaS
 * templates: the three consolidated forms (`DaasProjectInput`,
 * `DaasApplicationInput`, `DaasApplicationSetInput`) and the standalone
 * `DaasComponentPicker` used by the delete templates. Attaches to the
 * scaffolder page's `formFields` input via `pluginId: 'scaffolder'`.
 */
export const daasScaffolderFieldsModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: fields.map(({ id, name, component, validation }) =>
    FormFieldBlueprint.make({
      name: id,
      params: {
        field: async () => createFormField({ name, component, validation }),
      },
    }),
  ),
});
